// modal okna
if ($('.js-invoice-data-check').length) {
  invoiceData();
}

function invoiceData() {
  // $('.js-invoice-data-check').on('click', function () {

  //   if ($('.js-invoice-data').hasClass('is-hidden')) {
  //     $('.js-invoice-data').slideDown(300).removeClass('is-hidden');
  //     alert('test');
  //   }

  //   else {
  //     $('.js-invoice-data').slideUp(300).addClass('is-hidden');
  //   }
  // });

  $(document).ready(function () {
    $('.js-invoice-data-check').click(function () {
      if ($(this).prop('checked') == true) {
        $('.js-invoice-data').slideDown(300);
      } else if ($(this).prop('checked') == false) {
        $('.js-invoice-data').slideUp(300);
      }
    });
  });
}
